<template>
    <v-list>
        <v-list-item>
            <SoliAvatarBtn
                @click="
                    $emit('input', {
                        lesson: true,
                        display: 'Lesson',
                        name: 'Assessment',
                    })
                "
                title="Assessment Lesson"
                subtitleBottom="30 minutes"
                avatar="/instruments-blue.webp"
                blue
            />
        </v-list-item>
        <v-list-item>
            <SoliAvatarBtn
                @click="
                    $emit('input', {
                        apl: true,
                        display: 'Piano Lab',
                        name: 'Piano Lab Assessment',
                        event: event,
                        instrument: instrument,
                    })
                "
                title="Piano Lab Assessment"
                subtitleBottom="15 minutes"
                avatar="/apl-assessment.webp"
                blue
            />
        </v-list-item>
    </v-list>
</template>

<script>
``;
export default {
    data() {
        return {
            event: null,
            instrument: null,
        };
    },
    mounted() {
        this.getEvent();
        this.getInstrument();
    },
    methods: {
        getEvent() {
            axios
                .get(
                    route("lessons.firstEventByTitle", "Accelerated Piano Lab")
                )
                .then((resp) => {
                    this.event = resp.data;
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
        getInstrument() {
            axios
                .get(route("instruments.firstByName", "Piano"))
                .then((resp) => {
                    this.instrument = resp.data;
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
    },
};
</script>
